import { createSection } from '@formkit/inputs'
import Trash from '@/assets/trash.svg?component'

const TrashComponent = markRaw(Trash)

export const schema = createSection('input', () => ({
  $el: 'div',
  attrs: {
    class: '$classes.container'
  },
  children: [
    {
      $el: 'div',
      attrs: {
        class: 'flex flex-col'
      },
      children: [
        {
          $el: 'ul',
          if: '$value.length',
          attrs: {
            class: 'flex flex-wrap flex-row gap-[5px] mt-[10px]',
            'data-has-multiple': {
              if: '$value.length > 1',
              then: 'true'
            }
          },
          children: [
            {
              $el: 'li',
              for: ['fileItem', '$value'],
              attrs: {
                class: 'inline-flex flex-col border border-gray-400 rounded py-[5px]'
              },
              children: [
                {
                  $el: 'button',
                  attrs: {
                    type: 'button',
                    'aria-label': 'Usuń zdjęcie',
                    class: 'inline-flex gap-[5px] justify-center items-center self-end px-[5px] uppercase text-12 text-red',
                    onClick: '$handlers.removeFile($fileItem)',
                    disabled: '$disabled',
                  },
                  children: [
                    'Usuń',
                    {
                      $cmp: TrashComponent,
                      attrs: {
                        class: 'ml-[5px]'
                      }
                    }
                  ]
                },
                {
                  $el: 'div',
                  attrs: {
                    class: 'flex flex-col justify-center mt-[5px]'
                  },
                  children: [
                    {
                      $el: 'div',
                      attrs: {
                        class: 'flex flex-col justify-center w-[200px] h-[120px]'
                      }, children: [
                        {
                          $el: 'img',
                          if: '$fns.getPreviewUrl($fileItem)',
                          attrs: {
                            width: '200',
                            height: '120',
                            class: 'max-w-full max-h-full h-auto object-contain flex-1',
                            src: '$fns.getPreviewUrl($fileItem)'
                          }
                        },
                      ]
                    },
                    {
                      $el: 'span',
                      attrs: {
                        class: 'text-center font-medium m-[4px] text-clip overflow-hidden'
                      },
                      children: '$fileItem.name'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          $el: 'div',
          attrs: {
            class: 'flex mt-[10px] gap-[2px]'
          },
          children: [
            {
              $el: 'div',
              attrs: {
                class: 'relative flex-1'
              },
              children: [
                {
                  $el: 'input',
                  bind: '$attrs',
                  attrs: {
                    type: 'file',
                    disabled: '$disabled',
                    class: 'peer absolute cursor-pointer h-full w-full opacity-0',
                    name: '$node.name',
                    onChange: '$handlers.files',
                    onBlur: '$handlers.blur',
                    id: '$id'
                  }
                },
                {
                  $el: 'span',
                  attrs: {
                    class: 'relative flex justify-center w-full h-full p-[14px] pointer-events-none text-placeholder border tranistion-colors duration-300 ease-in-out border-gray-400 peer-hover:border-gray-500 peer-focus:border-gray-500 rounded peer-hover:text-green peer-focus:text-green'
                  },
                  children: [
                    {
                      $el: 'i',
                      attrs: {
                        class: 'icon-close rotate-45 text-10'
                      }
                    }
                  ]
                }
              ]
            },
            {
              $el: 'button',
              if: '$value.length > 1',
              attrs: {
                title: 'Usuń wszystkie zdjęcia',
                'aria-label': 'Usuń wszystkie zdjęcia',
                type: 'button',
                disabled: '$disabled',
                onClick: '$handlers.resetFiles',
                class: 'rounded p-[14px] text-12 text-red border border tranistion-colors duration-300 ease-in-out border-gray-400 hover:border-gray-500 focus:border-gray-500'
              },
              children: [
                {
                  $cmp: TrashComponent
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}))

export default schema